import type { GetTokenSilentlyOptions } from '@auth0/auth0-react';
import type { AxiosInstance } from 'axios';

type GetTokenSilently = (options?: GetTokenSilentlyOptions) => Promise<string>;

/**
 * Attaches an Axios request interceptor that injects the Auth0 access token
 * into every outgoing request as a Bearer token.
 *
 * Call this once when creating the Axios instance, passing in
 * `getAccessTokenSilently` from the Auth0 SDK.
 */
export function withAuthAxios(
  axiosInstance: AxiosInstance,
  getToken: GetTokenSilently,
): AxiosInstance {
  axiosInstance.interceptors.request.use(async (config) => {
    try {
      const token = await getToken();
      config.headers.Authorization = `Bearer ${token}`;
    } catch {
      // Token refresh failed — let the request proceed without a token.
      // The 401 response interceptor in api-client will handle the redirect.
    }
    return config;
  });

  return axiosInstance;
}
